import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=78885912&scoped=true"
import script from "./AddressEdit.vue?vue&type=script&lang=js"
export * from "./AddressEdit.vue?vue&type=script&lang=js"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&id=78885912&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78885912",
  null
  
)

export default component.exports